// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Cisk","rootCenter":"LoadMoreObserver_rootCenter__1JLdW","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2jtxN"};